import { Component, OnInit, Input } from '@angular/core';
import { IDashboardCard } from 'projects/common/src/app/types';
@Component({
	selector: 'app-d-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
	@Input() title: string;
	@Input() description: string;
	@Input() dashboardCards: IDashboardCard[];
	constructor() {
		this.dashboardCards = [];
	}

	ngOnInit() {
		this.dashboardCards = this.dashboardCards.filter(c => !c.notShow);
	}
}
